import MutateSponsorshipTier from "./MutateSponsorshipTier";

export default MutateSponsorshipTier